import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from './utils/api';

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$api = api;

window.channel = "hz"
if (window.channel == "fz") {
  window.request_host = "https://api.311419.com"
} else if (window.channel == "hz") {
  window.request_host = "https://game.buercamp.com";
} else if (window.channel == "vivo") {
  window.request_host = "https://quick.91mgame.com";
} else if (window.channel == "xm") {
  window.request_host = "https://xiaomi.buercamp.com";
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
